import { RESET } from '../actionTypes';
import { createProposalModalActions } from '../reducer';

export default () => createProposalModalActions[RESET]();
